import React from 'react'
import styles from './index.module.css'

const list = [
    {
        id: 1,
        pre: 'Военнослужащие в запасе',
        text: 'помощь в адаптации к гражданской жизни, поиск работы, восстановление психологического состояния'
    },
    {
        id: 2,
        pre: 'Ветераны боевых действий',
        text: 'поддержка в преодолении ПТСР, работа с тревогой, стрессом, социализацией'
    },
    {
        id: 3,
        pre: 'Семьи военнослужащих',
        text: 'психологическая поддержка для жены и детей, помощь в выстраивании отношений и адаптации к новым условиям'
    },
    {
        id: 4,
        pre: 'Люди после экстремального опыта',
        text: 'бывшие сотрудники силовых структур, которым нужно восстановить внутреннее равновесие'
    },
]

const Index = () => {
  return (
    <div className={styles.wrapper}>
        <div className={styles.title}>Для кого наш сервис?</div>
        <div className={styles.list}>
            {list.map(item => 
                <div key={item.id} className={styles.item + ' ' + styles.animated_blob}> 
                    <div className={styles.pre}>{item.pre}</div>
                    <div className={styles.text}>{item.text}</div>
                </div>
            )}
        </div>
    </div>
  )
}

export default Index